export enum ConversationSortType {
  TIMESTAMP = 'timestamp',
}

export default ConversationSortType;
